import { Colors } from '@oy/uicore';
import { Text } from '@oy/uidesktop';
import { LogoIcon, SystemIcon } from '@oy/uiicon';
import { Tooltip } from 'react-tooltip';
import { useTranslate } from 'src/hooks';
import styles from './BankAccountTooltip.module.css';

export const BankAccountTooltip = ({
  showTooltip,
  setShowTooltip,
  accountNumber,
  bankName,
}: {
  accountNumber: string;
  bankName: string;
  showTooltip: boolean;
  setShowTooltip: (val: boolean) => void;
}) => {
  const { getTranslation } = useTranslate();
  return (
    <>
      <Tooltip
        openOnClick
        isOpen={showTooltip}
        setIsOpen={setShowTooltip}
        anchorSelect="#menuDetailBalance"
        className={styles.container}
        place="right"
        clickable
        render={() => {
          return (
            <div>
              <div className={styles.headerContainer}>
                <span onClick={() => setShowTooltip(false)} role="button">
                  <SystemIcon name="close2" color={Colors.BLACK100} />
                </span>
                <Text textStyle={Text.Style.BodyXlSemibold}>
                  {getTranslation('overbooking_yourAccount')}
                </Text>
              </div>
              <hr style={{ margin: 0 }} />
              <div className={styles.contentContainer}>
                <Text textStyle={Text.Style.BodyMdRegular}>
                  {getTranslation('overbooking_description')}
                </Text>

                <div className={styles.productsContainer}>
                  <div className={styles.receiveMoneyContainer}>
                    <LogoIcon height={36} name="receive-money" />
                    <Text textStyle={Text.Style.BodySmRegular}>
                      {getTranslation('overbooking_acceptance')}
                    </Text>
                  </div>
                  <div className={styles.sendMoneyContainer}>
                    <LogoIcon height={36} name="send-money" />
                    <Text textStyle={Text.Style.BodySmRegular}>
                      {getTranslation('overbooking_disburse')}
                    </Text>
                  </div>
                </div>

                <div className={styles.bankInformationContainer}>
                  <div className={styles.bankInformationItem}>
                    <Text textStyle={Text.Style.BodyMdRegular}>
                      {getTranslation('common_bankName')}
                    </Text>
                    <Text textStyle={Text.Style.BodyMdSemibold}>
                      {bankName}
                    </Text>
                  </div>
                  <div className={styles.bankInformationItem}>
                    <Text textStyle={Text.Style.BodyMdRegular}>
                      {getTranslation('common_accountNumber')}
                    </Text>
                    <Text textStyle={Text.Style.BodyMdSemibold}>
                      {accountNumber}
                    </Text>
                  </div>
                  {/* <div className={styles.bankInformationItem}>
                    <Text textStyle={Text.Style.BodyMdRegular}>
                      {getTranslation('common_bankAccountName')}
                    </Text>
                    <Text textStyle={Text.Style.BodyMdSemibold}>
                      {bankName}
                    </Text>
                  </div> */}
                </div>
                <hr style={{ margin: 0 }} />
                <div className={styles.bottomSection}>
                  <SystemIcon name="information-filled" />
                  <Text textStyle={Text.Style.BodyMdRegular}>
                    {getTranslation('overbooking_info_checkBalance')}
                  </Text>
                </div>
              </div>
            </div>
          );
        }}
      />
    </>
  );
};
